const PRODUCTION_HOSTS = new Set(['tribaldash.co', 'www.tribaldash.co']);

function isProductionHost(hostname) {
  return PRODUCTION_HOSTS.has(hostname) || hostname.endsWith('.netlify.app');
}

/** True when the storefront can reach the API (same-origin proxy or local env URL). */
export function isBackendConfigured() {
  if (typeof window !== 'undefined' && isProductionHost(window.location.hostname)) {
    return true;
  }
  return !!(process.env.REACT_APP_BACKEND_URL || '').trim();
}

/**
 * Resolve an API path like `/api/orders`.
 * On tribaldash.co uses a relative path (same-origin HTTPS via Netlify proxy).
 */
export function getApiUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;

  if (typeof window !== 'undefined' && isProductionHost(window.location.hostname)) {
    return normalized;
  }

  const base = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  if (!base) return normalized;

  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && base.startsWith('http://')) {
    return `${base.replace(/^http:\/\//i, 'https://')}${normalized}`;
  }

  return `${base}${normalized}`;
}

/** @deprecated Use getApiUrl('/api/...') */
export function getBackendUrl() {
  if (typeof window !== 'undefined' && isProductionHost(window.location.hostname)) {
    return window.location.origin;
  }
  return (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
}
